import request from '@/utils/http';

// 主页列表数据
export const getSearchList = (params) => {
    return request({
        url: `/api-tms/transportChoose/search`,
        method: 'post',
        data: params
    });
};

// 删除
export const deleteByIds = (id) => {
    return request({
        url: `/api-tms/transportChoose/${id}`,
        method: 'delete'
    });
};

// 新增、编辑
export const saveDate = (params) => {
    return request({
        url: `/api-tms/transportChoose/save`,
        method: 'post',
        data: params
    });
};
// 获取编辑自定义条件
export const getTransportChooseAndDetail = (id) => {
    return request({
        url: `/api-tms/transportChoose/getTransportChooseAndDetailById/${id}`,
        method: 'get'
    });
};
